<template>
  <div>
    <Header></Header>
    <Header1></Header1>
    <NewsList></NewsList>
  </div>
</template>
<script>
import Header from "./header.vue";
import Header1 from "./header1.vue";
import NewsList from "./newList.vue";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Header1,
    NewsList
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
</style>    